import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=5b4f5363&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=5b4f5363&prod&lang=scss"
import style1 from "./notifications.vue?vue&type=style&index=1&id=5b4f5363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4f5363",
  null
  
)

export default component.exports